import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { isEmpty } from "lodash";

import { toastErrorMessage } from "../../utils/toastMessage/toastMessage";

const ExportCSV = ({ csvData }) => {
  const [props, setProps] = useState({
    data: [],
    headers: [],
    filename: "karbama",
    isDownload: false,
  });

  const onClick = () => {
    const { headers, data, fileName } = csvData();
    setProps((prev) => ({
      headers,
      data,
      filename: fileName || prev.filename,
      isDownload: true,
    }));
  };

  useEffect(() => {
    if (props.isDownload) {
      if (isEmpty(props.data)) toastErrorMessage("داده ای برای خروجی یافت نشد");
      else {
        document.getElementById("linkRef")?.click();
        setProps((prev) => ({ ...prev, isDownload: false }));
      }
    }
  }, [props]);

  return (
    <>
      <button className="btn btn-outline-success" onClick={onClick}>
        <i className="fas fa-file-excel" /> خروجی اکسل
      </button>
      <CSVLink
        id="linkRef"
        headers={props.headers}
        data={props.data}
        filename={`${props.filename}.csv`}
      />
    </>
  );
};

export default ExportCSV;
